import { Locale } from '@enmon/commons';
import { SerializedInventoryLocation, User } from '@enmon/commons/lib/tools';
import create from 'zustand';
import { devtools } from 'zustand/middleware';

const API_KEY_KEY = 'apiKey';
const EMAIL_KEY = 'email';
const LOCALE_KEY = 'locale';

export interface SessionState {
  isAuthenticated: boolean;
  apiKey: SerializedInventoryLocation['api_key'];
  email: User['email'] | null;
  locale: Locale;
  setLocale: (locale: Locale) => void;
}

export const useSessionStore = create<SessionState>(
  // NOTE: show state change actions in Redux devtools extension
  devtools<SessionState>(
    set => ({
      isAuthenticated: false,
      apiKey: new URLSearchParams(window.location.search).get(API_KEY_KEY) ?? localStorage.getItem(API_KEY_KEY) ?? null,
      email: localStorage.getItem(EMAIL_KEY) ?? null,
      locale: (localStorage.getItem(LOCALE_KEY) as Locale) ?? Locale.CS,
      setLocale: (locale: Locale) => {
        set({ locale });
        localStorage.setItem(LOCALE_KEY, locale);
      },
    }),
    'Session',
  ),
);

// sync apiKey to localStorage
useSessionStore.subscribe(({ apiKey }) => {
  if (apiKey) {
    localStorage.setItem(API_KEY_KEY, apiKey);
  } else {
    localStorage.removeItem(API_KEY_KEY);
  }
});

// sync email to sessionStorage
useSessionStore.subscribe(({ email }) => {
  if (email) {
    localStorage.setItem(EMAIL_KEY, email);
  } else {
    localStorage.removeItem(EMAIL_KEY);
  }
});
